module.exports = __webpack_public_path__ + "img/helloo.715c7244.svg";